import { useState } from 'react'
import { OffersScreen } from './offers-screen'
import { useDiscountsHomeOffersQuery, useDiscountsHomeQuery } from './queries'
import { dedupeDiscountsIds } from './lib/dedupe-discounts-ids'

export interface OffersScreenContainerProps {
  preview?: boolean
}

export const OffersScreenContainer = (props: OffersScreenContainerProps) => {
  const [refreshing, setRefreshing] = useState(false)
  const {
    loading: contentLoading,
    data: discountsData,
    refetch: refetchDiscounts,
    error,
  } = useDiscountsHomeQuery({
    draft: !!props.preview,
  })
  const dedupeIds = dedupeDiscountsIds(discountsData?.DiscountsHome?.content || [])

  const {
    loading: offersLoading,
    data: offersData,
    fetchMore,
    refetch: refetchOffers,
  } = useDiscountsHomeOffersQuery({
    variables: {
      page: 1,
      limit: 6,
      dedupeIds,
    },
    skip: contentLoading,
  })

  const handlePullToRefresh = async () => {
    setRefreshing(true)
    await Promise.all([refetchDiscounts(), refetchOffers()])
    setRefreshing(false)
  }

  const hasMore = (offersData?.fetchOffers?.page || 0) < (offersData?.fetchOffers?.totalPages || 0)

  const handleLoadMore = () => {
    fetchMore({
      variables: {
        page: (offersData?.fetchOffers?.page || 0) + 1,
      },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult) {
          return prev
        }
        return {
          fetchOffers: {
            ...fetchMoreResult.fetchOffers,
            docs: [...(prev.fetchOffers?.docs || []), ...(fetchMoreResult.fetchOffers?.docs || [])],
          },
        }
      },
    })
  }

  return (
    <OffersScreen
      loading={contentLoading}
      content={discountsData?.DiscountsHome.content || []}
      offers={offersData?.fetchOffers?.docs || []}
      meta={discountsData?.DiscountsHome.meta}
      error={error}
      hasMore={hasMore}
      loadingMore={offersLoading}
      onLoadMore={handleLoadMore}
      refreshing={refreshing}
      onPullToRefresh={handlePullToRefresh}
    />
  )
}
